import { render, staticRenderFns } from "./ChefMenu.vue?vue&type=template&id=60116ad8&"
import script from "./ChefMenu.vue?vue&type=script&lang=js&"
export * from "./ChefMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports